import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DateUtility } from '../../utils/date-utility';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { UserSessionService } from '../user-session/user-session.service';

@Injectable({
    providedIn: 'root',
})
export class ActiveSessionsService {
    private readonly url = `/api/active-sessions`;
    private readonly apiUrl = environment.apiUrl;

    constructor(
        private http: HttpClient,
        private session: UserSessionService,
    ) {}

    sendHeartbeat(): Observable<void> {
        const defaultHeaders = {
            Authorization: `Bearer ${this.session.token.access_token}`,
            'Accept-Language': 'en',
            'X-TimeZone': DateUtility.prototype.getTimeZone(),
            'X-Role': 'doctor',
        };

        return this.http.post<void>(
            `${this.apiUrl}${this.url}/heartbeat`,
            {},
            { headers: new HttpHeaders(defaultHeaders) },
        );
    }
}
